module.exports = __webpack_public_path__ + "img/dag_yes.4a18594a.png";